(function () {
  var root = document.querySelector('[data-armar-pack]');
  if (!root) return;

  var bar = document.createElement('div');
  bar.className = 'pack-sticky-bar';
  bar.innerHTML = [
    '<div class="pack-sticky-bar__inner">',
      '<div class="pack-sticky-bar__progress">',
        '<div class="pack-sticky-bar__row">',
          '<p class="pack-sticky-bar__bottles"><strong data-sb-count>0</strong> <span>de <span data-sb-size>6</span> botellas</span></p>',
          '<div class="pack-sticky-bar__price"><span data-sb-total></span><span class="pack-sticky-bar__discount" data-sb-discount></span></div>',
        '</div>',
        '<div class="pack-sticky-bar__bar"><div class="pack-sticky-bar__fill" data-sb-fill></div></div>',
      '</div>',
      '<button type="button" class="armar-pack__submit button button--primary pack-sticky-bar__cta" data-sb-cta disabled>',
        '<span data-sb-cta-label>Completá el pack</span>',
      '</button>',
    '</div>'
  ].join('');
  document.body.appendChild(bar);

  var sbCount = bar.querySelector('[data-sb-count]');
  var sbSize  = bar.querySelector('[data-sb-size]');
  var sbFill  = bar.querySelector('[data-sb-fill]');
  var sbTotal = bar.querySelector('[data-sb-total]');
  var sbDiscount = bar.querySelector('[data-sb-discount]');
  var sbCta   = bar.querySelector('[data-sb-cta]');
  var sbCtaLabel = bar.querySelector('[data-sb-cta-label]');

  var moneyFormat = root.dataset.moneyFormat || '';
  var pack6Discount  = parseFloat(root.dataset.pack6Discount  || '0') / 100;
  var pack12Discount = parseFloat(root.dataset.pack12Discount || '0') / 100;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var formatted = intPart + ',' + parts[1];
    if (moneyFormat && moneyFormat.indexOf('{{') !== -1) {
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intPart)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intPart);
    }
    return '$' + formatted;
  }

  function getDiscountForSize(s) {
    if (s === 6)  return pack6Discount;
    if (s === 12) return pack12Discount;
    return 0;
  }

  function sync() {
    var countEl = root.querySelector('[data-count]');
    var totalEl = root.querySelector('[data-total]');
    var stepBuild = root.querySelector('[data-step="build"]');

    if (!countEl || !totalEl || !stepBuild || stepBuild.hidden) {
      bar.classList.remove('is-visible');
      return;
    }

    var count = parseInt(countEl.textContent, 10) || 0;
    var sizeDisplayEl = root.querySelector('[data-pack-size-display]');
    var packSize = sizeDisplayEl ? parseInt(sizeDisplayEl.textContent, 10) : 0;

    if (!packSize) { bar.classList.remove('is-visible'); return; }

    var productCards = Array.from(root.querySelectorAll('[data-step="build"] [data-product-card]'));
    var subtotalCents = 0;
    productCards.forEach(function(card) {
      var qtyEl = card.querySelector('[data-qty-display]');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      if (qty > 0) subtotalCents += parseInt(card.dataset.variantPrice, 10) * qty;
    });

    var discount = getDiscountForSize(packSize);
    var discountCents = Math.round(subtotalCents * discount);
    var totalCents = subtotalCents - discountCents;

    sbCount.textContent = count;
    sbSize.textContent  = packSize;
    sbFill.style.width  = Math.min(100, (count / packSize) * 100) + '%';

    if (count > 0) {
      sbTotal.textContent = formatMoney(totalCents);
      sbDiscount.textContent = discountCents > 0
        ? '-' + Math.round(discount * 100) + '% aplicado'
        : (packSize >= 3 ? 'Envío gratis' : '');
    } else {
      sbTotal.textContent = '';
      sbDiscount.textContent = '';
    }

    var isFull = count === packSize;
    sbCta.disabled = !isFull;
    sbCtaLabel.textContent = isFull
      ? 'Agregar al carrito'
      : 'Te faltan ' + (packSize - count) + ' botella' + (packSize - count === 1 ? '' : 's');

    bar.classList.add('is-visible');

    sbCta.onclick = function() {
      var realSubmit = root.querySelector('[data-submit]');
      if (realSubmit && !realSubmit.disabled) realSubmit.click();
    };
  }

  var observer = new MutationObserver(sync);
  observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true });

  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
